/**
 * Rewrites SKU-style searches to Shopify field queries (variants.sku:TERM) while keeping visible search inputs free of the internal prefix.
 */
(() => {
  'use strict';

  const SKU_QUERY_PREFIX = 'variants.sku:';
  const SEARCH_PATH = document.currentScript?.dataset.searchPath ?? '/search';

  /** Permissive matchers applied after separator normalization. */
  const SKU_PATTERNS = [
    /^[A-Z]{2,8}\d{1,}[A-Z0-9]*$/i, // BRV6156, BRV-6156, BRV12RM, BRV5471INSERT
    /^\d{4,}$/, // 6156, 6020 (numeric-only codes)
  ];

  const normalizeTerm = (term = '') => {
    const trimmed = term.trim();
    return trimmed.startsWith(SKU_QUERY_PREFIX)
      ? trimmed.slice(SKU_QUERY_PREFIX.length)
      : trimmed;
  };

  /** Strips separators and uppercases for matching and Shopify field queries. */
  const normalizeSkuCandidate = (term) =>
    normalizeTerm(term).replace(/[-_\s]+/g, '').toUpperCase();

  const isSkuSearch = (term) => {
    const candidate = normalizeSkuCandidate(term);
    return candidate.length > 0 && SKU_PATTERNS.some((pattern) => pattern.test(candidate));
  };

  const toSkuQuery = (term) => `${SKU_QUERY_PREFIX}${normalizeSkuCandidate(term)}`;
  const isSearchForm = (form) => form?.getAttribute('action') === SEARCH_PATH;

  const cleanSearchUI = () => {
    document.querySelectorAll('input[name="q"]').forEach((input) => {
      const cleaned = normalizeTerm(input.value);
      if (cleaned !== input.value) input.value = cleaned;
    });

    if (document.title.includes(SKU_QUERY_PREFIX)) {
      document.title = document.title.replaceAll(SKU_QUERY_PREFIX, '');
    }
  };

  const applySkuQueryField = (form) => {
    const input = form.querySelector('input[name="q"]');
    if (!input || !isSkuSearch(input.value)) return;

    input.removeAttribute('name');
    form.append(
      Object.assign(document.createElement('input'), {
        type: 'hidden',
        name: 'q',
        value: toSkuQuery(input.value),
      })
    );
  };

  document.addEventListener(
    'submit',
    (event) => {
      if (isSearchForm(event.target)) applySkuQueryField(event.target);
    },
    true
  );

  if (window.location.pathname !== SEARCH_PATH) return;

  const params = new URLSearchParams(window.location.search);
  const rawQuery = (params.get('q') ?? '').trim();

  if (rawQuery && !rawQuery.startsWith(SKU_QUERY_PREFIX) && isSkuSearch(rawQuery)) {
    params.set('q', toSkuQuery(rawQuery));
    window.location.replace(`${SEARCH_PATH}?${params}`);
    return;
  }

  cleanSearchUI();
})();
